$(document).ready(function(){
  
  
  /* SECTION -- faq-collapsible-content.liquid [ FAQ Page ] -----> QUESTIONs Click event */
  if($('[data-faq-tab]').length){
    $(document).on("click","[data-faq-tab] [data-faq-que]",function(){
      $(this).closest("[data-faq-tab]").siblings().removeClass("active").find("[data-faq-ans]").slideUp();
      $(this).closest("[data-faq-tab]").toggleClass("active");
      $(this).closest("[data-faq-tab]").find("[data-faq-ans]").slideToggle();
    });
  }
  /* END SECTION -- faq-collapsible-content.liquid [ FAQ Page ] -----> QUESTIONs Click event */


  /*
  -----------------------------
  START -- ALL HOME PAGE JS
  -----------------------------*/

  /*START -- Navigation menu*/
    $(document).on("mouseenter","header-menu details",function(e){
      $('header-menu details').removeAttr('open');
      $(this).attr('open','');
    });
    $(document).on("mouseleave","header.header .header__inline-menu>ul .mega-menu__content",function(e){    
      $('header-menu details').removeAttr('open');
    });
    $(document).mouseleave(function (e) {      
      $('header-menu details').removeAttr('open');
    });
  /*END -- Navigation menu*/
  
  if($('.template--index').length){

    /* START Hero section slider */
    if($('[data-hero-section]').length){
      heroSection();
    }
    /* END Hero section slider */

    /* START home page category carousel slider */
    if($('.category-carousel [data-category-carousel-slider]').length){
      categoryCarousel();
    }
    /* END home page category carousel slider */
    
     /* START home page featured collection carousel */
    if($('.featured-collection-carousel [data-featured-collection-slider]').length){
      featuredCollectionCarousel();
    }
    /* END home page featured collection carousel */

     /* START home page product testimonial carousel */
    if($('.product-testimonial-carousel [data-product-testimonial-slider]').length){
      productTestimonialCarousel();
    }
    /* END home page product testimonial carousel */
    

    // section --> home-country-service.liquid  [ JS -- START ]
    if($(".home-country-service-wrapper").length){
      
      // $(document).on("mouseenter","[data-country-item]",function(e){
      //   e.preventDefault();
      //   $(this).siblings().removeClass("open").find("[data-country-services]").stop().slideUp();
      //   $(this).addClass("open").find("[data-country-services]").stop().slideDown();
  
      //   var handle = $(this).attr("data-country-handle");
      //   //for flag
      //   $("[data-country-flag-wrap] .country-flags-item").removeClass("active");
      //   $("[data-country-flag-wrap] .country-flags-item."+ handle +"").addClass("active");
  
      //   //for imgs
      //   $("[data-country-img-wrap] .country-img").removeClass("visible");
      //   $("[data-country-img-wrap] .country-img."+ handle +"").addClass("visible");
      // });
      // $(document).on("mouseleave",".country-services-wrapper",function(e){
      //   $("[data-country-item]").removeClass("open").find("[data-country-services]").stop().slideUp();
      //   $("[data-country-flag-wrap] .country-flags-item").removeClass("active");
      //   $("[data-country-img-wrap] .country-img").removeClass("visible");
      //   $("[data-country-img-wrap] .country-img.def-img").addClass("visible");
      // });

      $(document).on({
        mouseenter: function () {
          //stuff to do on mouse enter
          var handle = $(this).attr("data-country-handle");

          $(this).siblings().removeClass("open").find("[data-country-services]").stop().slideUp();
          $(this).addClass("open").find("[data-country-services]").stop().slideDown();
          
          //for flag
          $(this).closest('.country-services-wrapper').find(`[data-country-flag-wrap] .country-flags-item`).removeClass("active");
          $(this).closest('.country-services-wrapper').find(`[data-country-flag-wrap] .country-flags-item.${handle}`).addClass("active");
  
          //for imgs
          $(this).closest('.country-services-wrapper').find(`[data-country-img-wrap] .country-img`).removeClass("visible");
          $(this).closest('.country-services-wrapper').find(`[data-country-img-wrap] .country-img.${handle}`).addClass("visible");
        },
        mouseleave: function () {
          //stuff to do on mouse leave
          $("[data-country-item]").removeClass("open").find("[data-country-services]").stop().slideUp();
          $("[data-country-flag-wrap] .country-flags-item").removeClass("active");
          $("[data-country-img-wrap] .country-img").removeClass("visible");
          $("[data-country-img-wrap] .country-img.def-img").addClass("visible");
        }
      }, "[data-country-item]");
      
    }
    // section --> home-country-service.liquid  [ JS -- END ]
    
  }
  
  /*
  ---------------------------
  END -- ALL HOME PAGE JS 
  ---------------------------*/


  /*
  ---------------------------
  START -- ALL PRODUCT PAGE JS 
  ---------------------------*/
  
  if($('.template--product').length){

    /* START product page accordian */
    if($('[data-pdp-accordion] .accordion').length){
      $(document).on("click","[data-pdp-accordion] .accordion button", function(e){
        $('[data-pdp-accordion] .accordion button').attr('aria-expanded','false');
        $(this).closest(".accordion-item").siblings().removeClass("active").find(".accordion-content").slideUp();
        $(this).closest(".accordion-item").toggleClass("active");
        $(this).closest(".accordion-item").find(".accordion-content").slideToggle();
        if($(this).closest(".accordion-item").hasClass('active')){
          $(this).attr('aria-expanded', 'true');
        }
      });
    }
    /* END product page accordian */

    /* START pdp juicer product page testimonial carousel */
    if($('.template-pdp-juicer .juicer-testimonial [data-juicer-testimonial]').length){
      juicerTestimonialCarousel();
    }
    /* END pdp juicer product page testimonial carousel */

    /* START pdp juicer product page featured collection carousel */
    if($('.template-pdp-juicer .featured-collection-carousel [data-featured-collection-slider]').length){
      featuredCollectionCarousel();
    }
   /* END pdp juicer product page featured collection carousel */

    /*START pdp juicer accordian drawer*/

    /*add dynamic content height of each individual drawer*/
    if($(window).width() < 750 && $('[data-juicer-accordion]').length){
      $('[data-juicer-accordion]').each(function (key,ele) {
        var contentBoxHeight = $(ele).find('.faq-retun').outerHeight(true) + $(ele).find('.content').outerHeight(true);  
        var getContentPadding = $(ele).find('.faq-content-box').outerHeight(true) - $(ele).find('.faq-content-box').height();
        if($(ele).find('.faq-dim-accordion').length){
          contentBoxHeight = $(ele).find('.faq-dim-accordion:not(.hidden)').outerHeight(true);
        }
        $(ele).find('.faq-content-box').css(`height`,`${contentBoxHeight+getContentPadding}px`);
      });
    }
    /*add dynamic content height of each individual drawer*/
    
    $(document).on('click','.template-pdp-juicer [data-juicer-size-btn]',function(e) {
      e.preventDefault();
      $('[data-size-slideout]').addClass('open');
      scrollBarPadding()
      $('body').addClass('overflow-hidden drawer--active');
    });
    $(document).on('click','.template-pdp-juicer [data-size-slideout-close]',function(e) {
      e.preventDefault();
      $('[data-size-slideout]').removeClass('open');
      $('body').css('padding-right','');
      $('body').removeClass('overflow-hidden drawer--active');
    });
    
    if($('.template-pdp-juicer [data-story-img-slide]').length){
      juicerStoryImgSlide();
    }

    $(document).on('click','.template-pdp-juicer [data-size-img-change]',function(e) {
      e.preventDefault();
      $(this).closest("[data-size-img-wrap]").toggleClass('changed');
    });

    $(document).on('click','.template-pdp-juicer [data-juicer-accordion-btn]',function(e) {
      e.preventDefault();
      $(this).closest("[data-juicer-accordion-wrap]").addClass('active');
      $(this).closest("[data-juicer-accordion]").addClass("open");
      scrollBarPadding();
      $('body').addClass('overflow-hidden drawer--active');
    });

    $(document).on('click','.template-pdp-juicer [data-juicer-accordion] [data-dim]',function(e) {
      e.preventDefault();
      var currentDim = $(this).attr('data-dim');
      $(this).closest('[data-juicer-accordion]').find('[data-size]').addClass('hidden');
      $(this).closest('[data-juicer-accordion]').find(`[data-size="${currentDim}"]`).removeClass('hidden');
    });

    $(document).on('click','.template-pdp-juicer [data-accordion-close]',function(e) {
      e.preventDefault();
      $('[data-juicer-accordion-wrap]').removeClass('active');
      $('[data-juicer-accordion]').removeClass('open');
      $('body').css('padding-right','');
      $('body').removeClass('overflow-hidden drawer--active');
    });
    $('body').on("click", function(e) {
      if (!$(e.target).closest('.faq-content-box').length && !$(e.target).closest('.juicer-size-content').length && $('body').hasClass('drawer--active')) {
        $('[data-juicer-accordion-wrap]').removeClass('active');
        $('[data-juicer-accordion]').removeClass('open');
        $('[data-size-slideout]').removeClass('open');
        $('body').css('padding-right','');
        $('body').removeClass('overflow-hidden drawer--active');
      }
    });
    
    /*END pdp juicer accordian drawer*/
    
    
  }
  
  /*
  ---------------------------
  END -- ALL PRODUCT PAGE JS 
  ---------------------------*/

  /*
  ---------------------------
  START -- ALL OTHER PAGE JS 
  ---------------------------*/

  if($('.template--page').length){

    /* START juicer template page featured collection carousel */
    if($('.featured-collection-carousel [data-featured-collection-slider]').length){
      featuredCollectionCarousel();
    }
    /* END juicer template page featured collection carousel */

    
    /* START juicer page testimonial carousel */
    if($('.juicer-testimonial [data-juicer-testimonial]').length){
      juicerTestimonialCarousel();
    }
    /* END juicer page testimonial carousel */

     /* START juicer page testimonial content carousel */
    if($('.juicer-image-text-slider [data-testominial-content-slider]').length){
      juicerTestimonialContentCarousel();
    }
    /* END juicer page testimonial content carousel */

    // juicer page -- accordion [ mobile ]
    if($(window).width() <= 749){
      $(document).on('click','[data-juicer-accordion] [data-juicer-accordion-btn]', function(e){
        e.preventDefault();
        console.log("clicked jquery");
        $(this).closest('[data-juicer-accordion]').siblings().removeClass('active').find('.faq-content').slideUp();
        $(this).closest('[data-juicer-accordion]').toggleClass('active').find('.faq-content').slideToggle();
      });
    }
    
  }
   /*
  ---------------------------
  END -- ALL OTHER PAGE JS 
  ---------------------------*/

  
});


function heroSection() {
 var menu = ['Slide 1', 'Slide 2']
 var swiperhero = new Swiper('[data-hero-section]', {
    effect: "fade",
    draggable: false,
    loop: true,
    noSwiping: true,
    allowTouchMove: false,
    autoplay: {
      delay: 4000
    }
  });

  // slide title click -- desktop
  let slideBtns = document.querySelectorAll("[data-hero-section] [data-hero-slide-title]");
  if(slideBtns.length){
    slideBtns.forEach( btn => {
      btn.addEventListener("click",(event) => {
        event.preventDefault();
        btn.closest("[data-hero-section]").swiper?.slideTo(Number(btn.dataset.index));
      });
    });
  }
}

function categoryCarousel() {
 var swiper = new Swiper('[data-category-carousel-slider]', {
      slidesPerView: 3,
      spaceBetween: 5,
      slidesPerGroup: 3,
      speed: 400,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar"
      },
      navigation: {
        nextEl: ".cate-button-next",
        prevEl: ".cate-button-prev",
      }, 
      breakpoints: {
        640: {
          slidesPerView: 3.5,
          spaceBetween: 12,
          slidesPerGroup: 3,
          speed: 500
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 12,
          slidesPerGroup: 4,
          speed: 600
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 12,
          slidesPerGroup: 5,
          speed: 700
        }
     }
  });
}

function featuredCollectionCarousel() {
  var mySwiper = new Swiper ('[data-featured-collection-slider]', {
	  slidesPerView: 1.5,
      spaceBetween: 12,    
      slidesPerGroup: 1,
      speed: 300,
      navigation: {
        nextEl: ".fea-col-slide-next",
        prevEl: ".fea-col-slide-prev",
      }, 
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
          speed: 400
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          speed: 500
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          speed: 600
        }
     }
  });
}


function productTestimonialCarousel() {
 var swiper = new Swiper('[data-product-testimonial-slider]', {
    slidesPerView: 1,
    effect: 'fade',
    speed: 500,
    // cssMode: true,
    pagination: {
      el: ".product-testimonial-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".testimo-button-next",
      prevEl: ".testimo-button-prev"
    }
  });
}

function juicerTestimonialCarousel() {
  let sectionSettings = JSON.parse($('.juicer-testimonial [data-section-setting]').attr('data-section-setting'));
  let autoplayDelay = false;
  if(sectionSettings.autoplay == 'true'){
    autoplayDelay = {
      delay : Number(sectionSettings.autoplay_delay),
      disableOnInteraction: false
    }
  }
 var swiper = new Swiper('[data-juicer-testimonial]', {
    autoHeight: false,
    speed: 700,
    autoplay: autoplayDelay,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction"
    },
    navigation: {
      nextEl: ".swiper-btn-next",
      prevEl: ".swiper-btn-prev"
    }
  });
}

function juicerTestimonialContentCarousel() {
 var swiper = new Swiper('[data-testominial-content-slider]', {
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-btn-next",
      prevEl: ".swiper-btn-prev"
    }
  });
}

function juicerStoryImgSlide() {
 var swiper = new Swiper('[data-story-img-slide]', {
    slidesPerView: 1.1,
    spaceBetween: 10, 
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      750: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    }
  });
}

function scrollBarPadding() {
  //add padding right only windows and linux device when drawer open for smooth transition
  let isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if(!isIOSDevice && !Shopify.designMode && window.matchMedia('(min-width: 990px)').matches){
    const scrollbarWidth = window.outerWidth-document.body.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}




/* wholesale tag */
if( window.userWholeSale == false && window.userHasWholeSale == true ){
  function getWcart(){
   fetch(`${routes.cart_url}.js`)
    .then((response) => response.text())
    .then((responseText) => {
      var cart = JSON.parse(responseText);
      checkWtag(cart);
    })
    .catch(e => {
      console.error(e);
    });
  }

  function checkWtag(cart){
   var cartItems = cart.items;
    for( var i = 0; i < cartItems.length; i++ ){
      if( cartItems[i].properties != null && cartItems[i].properties['wholesale'] != null ){
        removeTheWholesale( cartItems[i] );
        return;
      }
    }
  }
  
  function removeTheWholesale(cartItem){
    /*console.log('------------------------------------------------');
    console.log(cartItem.key, cartItem.properties, cartItem.title);*/
    var _key = cartItem.key, _properties = cartItem.properties;
    delete _properties['wholesale'];    
    var body = '';
    if( Object.keys(_properties).length == 0 ){      
      body = JSON.stringify({
        id : _key,
        quantity: 0
      });
      fetch(`${routes.cart_change_url}.js`, { ...fetchConfig('json'), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          var body = JSON.stringify({
            id: cartItem.variant_id,
            quantity: cartItem.quantity
          });
          fetch(`${routes.cart_add_url}.js`, { ...fetchConfig('json'), ...{ body } })
          .then((response) => response.json())
          .then((state) => {
            getWcart();            
          });          
        });
    }else{
      body = JSON.stringify({
        id : _key,
        properties: _properties
      });
      fetch(`${routes.cart_change_url}.js`, { ...fetchConfig('json'), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);          
          checkWtag(parsedState);
        })
    }
    /*console.log('------------------------END------------------------');*/
  }

  getWcart();
}
/* wholesale tag */


/* ***This will only render in the theme editor***** */
if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){

      const heroSlider = event.target.closest('.hero-slider') || null;
      if(heroSlider){
        heroSection();
      }
     const categoryCarouselContainer = event.target.closest('.category-carousel') || null;
      if(categoryCarouselContainer){
        categoryCarousel();
      }

      const featuredCollContainer = event.target.closest('.featured-collection-carousel') || null;
      if(featuredCollContainer){
        featuredCollectionCarousel();
      }

      const productTestimonialContainer = event.target.closest('.product-testimonial-carousel') || null;
      if(productTestimonialContainer){
        productTestimonialCarousel();
      }

      const juicerTestimonialContainer = event.target.closest('.juicer-testimonial') || null;
      if(juicerTestimonialContainer){
        juicerTestimonialCarousel();
      }

      const juicerTestimonialContentContainer = event.target.closest('.juicer-image-text-slider') || null;
      if(juicerTestimonialContentContainer){
        juicerTestimonialContentCarousel();
      }

    });
  });
}